import { Injectable } from "@angular/core";

// tslint:disable-next-line:import-blacklist
import { catchError, Observable, throwError } from "rxjs";
import { CreateUser } from "../../models/createUser";
import { SimpleUser, User } from "../../models/users";
import { environment } from "../../../environments/environment";
import { ACCESS_TOKEN } from '../../storage/constants.lib';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { UserQuery } from "../../models/user-query";
import { UserQueryResult } from "../../models/user-query-result";
import { ServiceFormatter } from "../../helpers/service-formatter";


@Injectable()
export class APIService {
  private endpoint = `${environment.baseURL}/api/`;

  constructor(private http: HttpClient) { }

  public getUsers = (): Observable<User[]> => {
    const token = localStorage.getItem(ACCESS_TOKEN);
    let headers = new HttpHeaders();
    //headers.append("Content-Type", 'application/json');
    headers = headers.append("Authorization", "Bearer " + token);
    const httpOptions = {
      headers: headers
    };
    return this.http
      .get<User[]>(this.endpoint + "user/getall", httpOptions)
      .pipe(
        catchError((error: Response) => this.handleError(error))
      );
  };

  public getUsersByQuery = (query: UserQuery): Observable<UserQueryResult> => {
    const token = localStorage.getItem(ACCESS_TOKEN);
    let headers = new HttpHeaders();
    //headers.append("Content-Type", 'application/json');
    headers = headers.append("Authorization", "Bearer " + token);
    const httpOptions = {
      headers: headers
    };
    return this.http
      .post<UserQueryResult>(this.endpoint + "user/query", query, httpOptions)
      .pipe(
        catchError((error: Response) => this.handleError(error))
      );
  };

  public getUserList = (): Observable<SimpleUser[]> => {
    const token = localStorage.getItem(ACCESS_TOKEN);
    let headers = new HttpHeaders();
    //headers.append("Content-Type", 'application/json');
    headers = headers.append("Authorization", "Bearer " + token);
    const httpOptions = {
      headers: headers
    };
    return this.http
      .get<SimpleUser[]>(this.endpoint + "user/getlist", httpOptions)
      .pipe(
        catchError((error: Response) => this.handleError(error))
      );
  };

  public getUsersWithDisabled = (): Observable<User[]> => {
    const token = localStorage.getItem(ACCESS_TOKEN);
    let headers = new HttpHeaders();
    //headers.append("Content-Type", 'application/json');
    headers = headers.append("Authorization", "Bearer " + token);
    const httpOptions = {
      headers: headers
    };
    return this.http
      .get<User[]>(this.endpoint + "user/getallwithdisabled", httpOptions)
      .pipe(
        catchError((error: Response) => this.handleError(error))
      );
  };

  public getCurrentUser = (): Observable<User> => {
    const token = localStorage.getItem(ACCESS_TOKEN);
    let headers = new HttpHeaders();
    //headers.append("Content-Type", 'application/json');
    headers = headers.append("Authorization", "Bearer " + token);


    const httpOptions = {
      headers: headers
    };
    return this.http
      .get<User>(this.endpoint + "user/getUser", httpOptions)
      .pipe(
        catchError((error: Response) => this.handleError(error))
      );
  };

  public makeSiteAdmin = (email: string): Observable<any> => {
    const token = localStorage.getItem(ACCESS_TOKEN);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    });
    return this.http
      .post(this.endpoint + "user/makesiteadmin", { email }, { headers })
      .pipe(
        catchError((error: Response) => this.handleError(error))
      );
  };

  public makePlainUser = (email: string): Observable<any> => {
    const token = localStorage.getItem(ACCESS_TOKEN);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    });
    return this.http
      .post(this.endpoint + "user/makeplainuser", { email }, { headers })
      .pipe(
        catchError((error: Response) => this.handleError(error))
      );
  };



  public makeReadOnlyUser = (email: string): Observable<any> => {
    const token = localStorage.getItem(ACCESS_TOKEN);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    });
    return this.http
      .post(this.endpoint + "user/makereadonlyuser", { email }, { headers })
      .pipe(
        catchError((error: Response) => this.handleError(error))
      );
  };



  public isAdmin = (): Observable<any> => {

    const token = localStorage.getItem(ACCESS_TOKEN);
    let headers = new HttpHeaders();
    //headers.append("Content-Type", 'application/json');
    headers = headers.append("Authorization", "Bearer " + token);
    const httpOptions = {
      headers: headers
    };
    return this.http
      .get(this.endpoint + "user/Admin", httpOptions)
      .pipe(
        catchError((error: Response) => this.handleError(error))
      );
  };




  public isSysAdmin = (): Observable<any> => {
    const token = localStorage.getItem(ACCESS_TOKEN);
    let headers = new HttpHeaders();
    //headers.append("Content-Type", 'application/json');
    headers = headers.append("Authorization", "Bearer " + token);
    const httpOptions = {
      headers: headers
    };
    return this.http
      .get(this.endpoint + "user/sysAdmin", httpOptions)
      .pipe(
        catchError((error: Response) => this.handleError(error))
      );
  };



  public addUser = (inputs: CreateUser): Observable<any> => {
    if (
      inputs.email == null &&
      inputs.email === ""
    ) {
      return throwError(() => new Error("You must complete email"));
    }
    const token = localStorage.getItem(ACCESS_TOKEN);
    let headers = new HttpHeaders();

    //headers.append("Content-Type", 'application/json');
    headers = headers.append("Authorization", "Bearer " + token);
    
    return this.http
      .post<{ id: string }>(
        this.endpoint + "user/Adduser2",
        inputs,
        { headers }
      )
      .pipe(catchError((error: Response) => this.handleError(error)));
  };

  public editUser = (inputs: CreateUser): Observable<any> => {
    if (
      inputs.email == null &&
      inputs.email === ""
    ) {
      return throwError(() => new Error("You must complete email"));
    }


    const token = localStorage.getItem(ACCESS_TOKEN);
    let headers = new HttpHeaders();

    //headers.append("Content-Type", 'application/json');
    headers = headers.append("Authorization", "Bearer " + token);
    const httpOptions = {
      headers: headers
    };
    return this.http
      .post(this.endpoint + "user/EditUser", inputs, httpOptions)
      .pipe(
        catchError((error: Response) => this.handleError(error))
      );
  };

  deleteUser(email: string): Observable<any> {
    const token = localStorage.getItem(ACCESS_TOKEN);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    });
    return this.http
      .post(this.endpoint + "user/delete", { email }, { headers })
      .pipe(
        catchError((error: Response) => this.handleError(error))
      );
  }

  sendVerifyEmail(userGuid: string): Observable<any> {
    const token = localStorage.getItem(ACCESS_TOKEN);
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token
    });
    return this.http
      .get(this.endpoint + "user/sendVerfiyEmail/" + userGuid, { headers })
      .pipe(
        catchError((error: Response) => this.handleError(error))
      );
  }

  unblockUser(email: string): Observable<any> {
    const token = localStorage.getItem(ACCESS_TOKEN);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    });
    return this.http
      .post(this.endpoint + "user/unblock", { email }, { headers })
      .pipe(
        catchError((error: Response) => this.handleError(error))
      );
  }

  sendResetPassword(email: string): Observable<any> {
    const token = localStorage.getItem(ACCESS_TOKEN);
    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", "application/x-www-form-urlencoded");
    headers = headers.append("Authorization", "Bearer " + token);
    const httpOptions = {
      headers: headers
    };
    return this.http
      .post(this.endpoint + "user/sendPasswordReset", "=" + email, httpOptions)
      .pipe(
        catchError((error: Response) => this.handleError(error))
      );
  }

  getExportPassword() {
    return this.http
    .get<any>(this.endpoint + "user/export-pw", ServiceFormatter.getHttpOptions())
    .pipe(
        catchError((error: Response) => this.handleError(error))
      );
  }

  private handleError(error: Response) {
    console.error(error);

    if (error.status === 401) {
      return throwError(() => new Error("Unauthorized"));
    }

    // Add more status-based error handling here if needed

    return throwError(() => new Error("Server error"));
  }

}
